import { BuildingDTO } from "./building";
import { Resource } from "./resource";

export type FacadeDto = {
  facadeId?: number;
  status: BuildingParticleStatus;
  particleId?: number;
  description?: string;
  facadePosition: FacadePosition;
  singlePlane?: SinglePlane;
  finishType?: FinishType;
  detailFinish?: string;
  insulated?: InsulatedStatus;
  adjacentToPublicDomain?: AdjacentToPublicDomain;
  grossArea?: number;
  corniceHeight?: number;
  cavityThickness?: number;
  sharePointPicturesFolderId?: string;
  sharePointPicturesFolderUrl?: string;
  installer: Resource;
  building: BuildingDTO;
  // Opleveringsdatum
  deliveryDate: Date;
  nextInspectionDate: Date;
}

export enum BuildingParticleStatus {
  TO_BE_CHECKED = "Na te kijken",
  GOOD = "Goede staat",
  BAD = "Slechte staat",
}

export enum FacadePosition {
  TO_BE_CHECKED = "Na te kijken",
  FRONT = "Voorgevel",
  BACK = "Achtergevel",
  SIDE_LEFT = "Zijgevel links",
  SIDE_RIGHT = "Zijgevel rechts",
}

export enum SinglePlane {
  TO_BE_CHECKED = "Na te kijken",
  YES = "Ja",
  NO = "Nee",
}

export enum FinishType {
  TO_BE_CHECKED = "Na te kijken",
  BRICK = "Baksteen",
  STONE_STRIPS = "Steenstrips",
  CREPI = "Crepi",
  NATURAL_STONE = "Natuursteen",
  WOOD = "Hout",
  KALEI = "Kalei",
  TILES = "Tegels",
  PLASTER = "Pleister",
}

export enum InsulatedStatus {
  TO_BE_CHECKED = "Na te kijken",
  YES = "Ja",
  NO = "Nee",
}

export enum AdjacentToPublicDomain {
  TO_BE_CHECKED = "Na te kijken",
  YES = "Ja",
  NO = "Nee",
}
